import { VehicleQuestionModel } from './vehicle-question.model';

export class VehicleStateModel {

  actualMileage: number;
  damageDescription: string;
  usageType: string;
  avgMileagePerYear: string;
  vehicleCondition: string;
  parkingPlace: string;
  countryOfOrigin: string;
  abroadImported: string;
  purchaseYear: number;
  purchaseMonth: number;
  questions: VehicleQuestionModel[]; // abroad, leasing, valid car inspection

  constructor() {
    this.questions = [];
  }
}
